<template>
  <div
    class="fixed left-0 top-0 bg-overlay w-full h-full z-65001"
  >
    <div
      class="bg-white fixed left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 rounded-lg p-4 flex flex-col max-h-screen-h-1/2 w-screen-w-2/3 gap-4"
    >
      <div class="uppercase font-medium text-roc-gray text-xl">
        Bonuses
      </div>
      <div class="flex flex-col h-96">
        <div class="flex flex-row gap-0.5">
          <Tab
            v-for="tab in tabs"
            :key="tab.id"
            :tab-id="tab.id"
            :tab-title="tab.title"
            :active="activeTab === tab.id"
            @click="activateTab"
          />
        </div>
        <div class="border border-gray-roc p-4 rounded-b rounded-tr flex flex-col gap-2 overflow-y-auto flex-grow">
          <BonusItem
            v-for="(bonus, index) in bonuses"
            :key="index + '-index'"
            :bonus="bonus"
          />
        </div>
        <div class="w-full flex flex-row justify-end mt-4">
          <button
            class="rounded bg-blue-roc hover:bg-gray-600 transition duration-300 text-white uppercase text-base py-2 px-8 cursor-pointer"
            @click="close"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {useApplicationStore} from '@/roc/stores/ApplicationStore';
import {computed, onMounted, ref} from 'vue';
import Tab from '@/components/Bonuses/Tab.vue';
import BonusItem from '@/components/Bonuses/BonusItem.vue';
import ArmyBonusCalculator from '@/components/Bonuses/Calculator/ArmyBonusCalculator';
import EraType from '@/roc/era/EraType';
import PassiveBonusCalculator from '@/components/Bonuses/Calculator/PassiveBonusCalculator';
import ProductionBonusCalculator from '@/components/Bonuses/Calculator/ProductionBonusCalculator';
import WorkersCalculator from "@/components/Bonuses/Calculator/WorkersCalculator";

export default {
  components: {BonusItem, Tab},
  setup () {
    const appStore = useApplicationStore();
    const activeTab = ref(null);

    onMounted(() => {
      activeTab.value = 'army';
    });

    return {
      activeTab,
      tabs: [
        { id: 'army', title: 'Army' },
        { id: 'passive', title: 'Passive' },
        { id: 'productions', title: 'Productions' },
        { id: 'workers', title: 'Workers' },
      ],
      activateTab (tabId) {
        activeTab.value = tabId;
      },

      close() {
        appStore.closeBonuses();
      },

      bonuses: computed(() => {
        const r = [];

        switch (activeTab.value) {
          case 'army':
            r.push(
              ...ArmyBonusCalculator.calculate(appStore.selectedEra || EraType.stoneAge)
            );
            break;

          case 'passive':
            r.push(
              ...PassiveBonusCalculator.calculate(appStore.selectedEra || EraType.stoneAge)
            );
            break;

          case 'productions':
            r.push(
              ...ProductionBonusCalculator.calculate(appStore.selectedEra || EraType.stoneAge)
            );
            break;

          case 'workers':
            r.push(
              ...WorkersCalculator.calculate(appStore.selectedEra || EraType.stoneAge)
            );
            break;
        }

        return r;
      })
    };
  }
};
</script>
